export default __webpack_public_path__ + "static/data-import-1ea5e9ae6659642b6fdedce7a08dd747.jpg";